<div class="w-full h-full p-6">
  <app-product-edit [isViewMode]="true" [isIframe]="isApproval"></app-product-edit>
</div>
